import { Component, ChangeDetectionStrategy, inject, OnInit, OnDestroy, effect } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AdminHeaderComponent } from './admin-header/admin-header';
import { AdminSidebarComponent } from './admin-sidebar/admin-sidebar';
import { CommonModule } from '@angular/common';
import { BranchService } from '../../services/branch.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { BranchSelectorDialogComponent } from '../../../features/branches/branch-selector-dialog/branch-selector-dialog';
import { InvoiceService } from '../../services/invoice.service';
import { HelpFabComponent } from '../../../shared/components/help-fab/help-fab.component';
import { ShiftHandoverGateComponent } from '../../../features/finance/cash-shift/shift-handover-gate/shift-handover-gate';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, AdminHeaderComponent, AdminSidebarComponent, HelpFabComponent, ShiftHandoverGateComponent],
  templateUrl: './admin-layout.html',
  styleUrl: './admin-layout.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private branchService = inject(BranchService);
  private invoiceService = inject(InvoiceService);
  private dialog = inject(MatDialog);

  private isInitialLoad = true;

  constructor() {
    // Escuchamos la necesidad de forzar la selección de sucursal
    effect(() => {
      const isSA = this.auth.isSuperAdmin();
      const workingBranchId = this.branchService.workingBranchId();
      const branches = this.branchService.userBranchesResource.value();
      const isLoading = this.branchService.userBranchesResource.isLoading();

      // SuperAdmin no tiene la obligación coercitiva de elegir sucursal
      if (isSA) return;
      
      // Si está cargando o no hay sucursales, no forzamos nada
      if (isLoading || !branches || branches.length === 0) return;

      // Si no hay sucursal de trabajo seleccionada, forzamos el modal
      // (La lógica de auto-select para 1 sucursal ya ocurrió en initializeSession)
      // salvo que haya elegido "Visión Global" a propósito desde el menú de sucursales
      if (workingBranchId === null && !this.branchService.globalElegido()) {
        this.openBranchSelector();
      }
    });

    // ─────────────────────────────────────────────────────────────────
    // ESCUCHA REALTIME: Notificaciones de Facturación (AFIP Webhooks)
    // ─────────────────────────────────────────────────────────────────
    effect(() => {
      const profile = this.auth.userProfile();
      if (profile?.business_id) {
        this.invoiceService.inicializarEscuchaRealtime(profile.business_id);
      }
    });
  }

  ngOnInit() { }

  private openBranchSelector() {
    // Evitar duplicados si ya está abierto
    if (this.dialog.openDialogs.some(d => d.componentInstance instanceof BranchSelectorDialogComponent)) {
      return;
    }

    this.dialog.open(BranchSelectorDialogComponent, {
      disableClose: true, // Obligatorio elegir
      maxWidth: '90vw',
      width: '600px',
      panelClass: 'branch-selector-panel'
    });
  }

  ngOnDestroy() {
    this.invoiceService.detenerEscuchaRealtime();
  }
}
